/**
 * Primer import de los paneles React: fija el tema antes de montar la app (y de que se inyecten
 * los estilos), para que no parpadee.
 */
import { aplicarTema } from './tema';

aplicarTema();
